import { getCohortTags } from "@/apis/cohorts/cohorts"

export default {
  data() {
    return {
      allCohortTags: [],
    }
  },
  methods: {
    getCohortTagsHTML(tagIds) {
      if (!tagIds) return ""
      let str = ""
      tagIds.forEach(id => {
        const tag = this.getTag(id)
        str += `<div class="bg-grey-light text-sm text-center rounded-sm px-1 mb-1">${
          tag ? tag.name : `id: ${id}`
        }</div>`
      })
      return str
    },
    getTag(id) {
      return this.allCohortTags.find(item => item.id === id)
    },
    fetchCohortTags() {
      getCohortTags()
        .then(res => {
          this.allCohortTags = res.data.items
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(
            "Failed to fetch cohort tags, cohort tags column will be empty"
          )
        })
    },
  },
}
